/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { GetAllAccessibleStudiesResponse } from '../models/GetAllAccessibleStudiesResponse';
import type { GetAllCrcAccessibleStudiesResponse } from '../models/GetAllCrcAccessibleStudiesResponse';
import type { GetAllStudiesResponse } from '../models/GetAllStudiesResponse';
import type { GetStudiesForAccessRequestActionResponse } from '../models/GetStudiesForAccessRequestActionResponse';
import type { GetStudiesResponse } from '../models/GetStudiesResponse';
import type { GetStudyOverviewResponse } from '../models/GetStudyOverviewResponse';
import type { GetStudyPatientsResponse } from '../models/GetStudyPatientsResponse';
import type { GetStudyProtocolResponse } from '../models/GetStudyProtocolResponse';
import type { GetStudySitesResponse } from '../models/GetStudySitesResponse';
import type { GetStudyUtilizationDataResponse } from '../models/GetStudyUtilizationDataResponse';
import type { GetTransferableSitesResponse } from '../models/GetTransferableSitesResponse';
import type { UpdateStudyInformationRequest } from '../models/UpdateStudyInformationRequest';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class StudyControllerV2Service {
    constructor(public readonly http: HttpClient) {}
    /**
     * @returns GetStudiesResponse
     * @throws ApiError
     */
    public studyControllerV2GetStudies(): Observable<GetStudiesResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/studies',
        });
    }
    /**
     * @returns GetStudyProtocolResponse
     * @throws ApiError
     */
    public studyControllerV2GetStudyProtocols(): Observable<Array<GetStudyProtocolResponse>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/studies/protocols',
        });
    }
    /**
     * @returns GetStudiesResponse
     * @throws ApiError
     */
    public studyControllerV2GetActiveStudies(): Observable<GetStudiesResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/studies/active',
        });
    }
    /**
     * @returns GetStudiesForAccessRequestActionResponse
     * @throws ApiError
     */
    public studyControllerV2GetStudiesForAccessRequestAction(): Observable<GetStudiesForAccessRequestActionResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/studies/access-request-action',
        });
    }
    /**
     * @returns GetAllAccessibleStudiesResponse
     * @throws ApiError
     */
    public studyControllerV2GetAllAccessibleStudies(): Observable<Array<GetAllAccessibleStudiesResponse>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/studies/list',
        });
    }
    /**
     * @returns GetAllCrcAccessibleStudiesResponse
     * @throws ApiError
     */
    public studyControllerV2GetAllCrcAccessibleStudies(): Observable<Array<GetAllCrcAccessibleStudiesResponse>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/studies/crc',
        });
    }
    /**
     * @param studyId
     * @returns GetStudyOverviewResponse
     * @throws ApiError
     */
    public studyControllerV2GetStudyOverview(
        studyId: number,
    ): Observable<GetStudyOverviewResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/studies/overview/{studyId}',
            path: {
                'studyId': studyId,
            },
        });
    }
    /**
     * @param studyId
     * @param studyLogoId
     * @returns binary
     * @throws ApiError
     */
    public studyControllerV2GetLogo(
        studyId: number,
        studyLogoId: number,
    ): Observable<Blob> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/studies/{studyId}/logo/{studyLogoId}',
            path: {
                'studyId': studyId,
                'studyLogoId': studyLogoId,
            },
        });
    }
    /**
     * @param studyId
     * @returns GetStudyPatientsResponse
     * @throws ApiError
     */
    public studyControllerV2GetStudyPatients(
        studyId: number,
    ): Observable<Array<GetStudyPatientsResponse>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/studies/{studyId}/patients',
            path: {
                'studyId': studyId,
            },
        });
    }
    /**
     * @param studyId
     * @returns number
     * @throws ApiError
     */
    public studyControllerV2CloseStudy(
        studyId: number,
    ): Observable<number> {
        return __request(OpenAPI, this.http, {
            method: 'PATCH',
            url: '/api/v2/studies/{studyId}/close',
            path: {
                'studyId': studyId,
            },
        });
    }
    /**
     * @param studyId
     * @returns GetStudySitesResponse
     * @throws ApiError
     */
    public studyControllerV2GetStudySites(
        studyId: number,
    ): Observable<Array<GetStudySitesResponse>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/studies/{studyId}/sites',
            path: {
                'studyId': studyId,
            },
        });
    }
    /**
     * @param studyId
     * @returns GetStudyUtilizationDataResponse
     * @throws ApiError
     */
    public studyControllerV2GetStudyUtilizationData(
        studyId: number,
    ): Observable<GetStudyUtilizationDataResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/studies/{studyId}/utilization',
            path: {
                'studyId': studyId,
            },
        });
    }
    /**
     * @returns GetAllStudiesResponse
     * @throws ApiError
     */
    public studyControllerV2GetAllStudies(): Observable<Array<GetAllStudiesResponse>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/studies/all',
        });
    }
    /**
     * @param requestBody
     * @returns binary
     * @throws ApiError
     */
    public studyControllerV2UpdateStudyInformation(
        requestBody: UpdateStudyInformationRequest,
    ): Observable<Blob> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/v2/studies/update/info',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param patientId
     * @returns GetTransferableSitesResponse
     * @throws ApiError
     */
    public studyControllerV2GetTransferableSites(
        patientId: number,
    ): Observable<GetTransferableSitesResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/studies/transferable-sites/{patientId}',
            path: {
                'patientId': patientId,
            },
        });
    }
}
